import {Component, Input, OnInit} from '@angular/core';
import {ExcTranslation} from 'exc-core-v2';
import {ExgModalService} from 'exc-controls-v2';
import {ApplicationService} from '../../services/application.service';
import {EnumerationService} from '../../services/enumeration.service';

@Component({
  selector: 'app-modal-oe-address',
  templateUrl: './modal-oe-address.component.html',
  styles: [
  ]
})
export class ModalOeAddressComponent extends ExcTranslation implements OnInit {
  @Input() data: any;

  dataModel: any;
  dataModelClone = {
    adr_enmIdent_AdresseTyp: -1,
    adrStr: '',
    adrHNum: '',
    adrZusatz: '',
    adrPlz: '',
    adrOrt: '',
    adrBez: '',
    adrLkz: 'DE',
  };

  constructor(
    public enumSvc: EnumerationService,
    private modalSvc: ExgModalService,
    public appSvc: ApplicationService
  ) {
    super();
  }

  ngOnInit(): void {
    if (!this.data) {
      this.dataModelClone = this.appSvc.helperObj.clone(this.dataModel);
    } else {
      this.dataModelClone = this.appSvc.helperObj.clone(this.data);
      this.dataModel = this.appSvc.helperObj.clone(this.data);
    }
  }

  delete(): void {
    this.modalSvc.action({adrID: this.dataModel.adrID, del: true});
  }

  cancel(): void {
    this.close();
  }

  close(): void {
    this.modalSvc.close();
  }

  save(): void {
    if (this.appSvc.helperObj.changed(this.dataModel, this.dataModelClone)) {
      this.modalSvc.action(this.dataModelClone);
    }
  }
}
